export enum SendTypeEnum {
  FromEdecide = 0,
  Download = 1,
  DoNotSend = 2,
}
